<!-- 行业报告详情页 -->
<template>
  <div class="all">
    <Header :Share="Share" :isShelves="isShelves" />
    <Shelves v-if="isShelves" />
    <div class="content-box" v-else>
      <!-- 顶部 -->
      <div class="top">
        <!-- 标题 -->
        <div class="title">
          <div class="left">
            <van-image
              width="100px"
              height="150px"
              :src="$global.imgUrl + DetailsList.cover"
            />
          </div>
          <div class="right">
            <div class="title">
              {{ DetailsList.reportName }}
            </div>
            <!-- <div class="author">
            <div style="margin-bottom: 5px;">作者</div>
            <span>{{DetailsList.englishName}}</span>
            <span>曾家维</span>
          </div> -->
            <!-- <div class="company">
            <div>出版单位</div>
            <span>{{DetailsList.businessId1name}}</span>
          </div> -->
          </div>
        </div>
        <!-- logo -->
        <div class="logo" @click="toAllParticulars(DetailsList)">
          <div v-if="userInfo.headImg" class="left">
            <van-image
              round
              width="50px"
              height="50px"
              fit="cover"
              :src="$global.imgUrl + userInfo.headImg"
            />
          </div>
          <div v-else class="left">
            <img style="width: 50px" src="@/assets/img/login/4.png" alt="" />
          </div>
          <div class="right">
            <div class="title">
              {{ userInfo.name }}
            </div>
            <div v-if="DetailsList.auditStatusTime" class="time">
              发布于：{{ DetailsList.auditStatusTime.slice(0, 4) }}年{{
                DetailsList.auditStatusTime.slice(5, 7)
              }}月{{ DetailsList.auditStatusTime.slice(8, 10) }}日
            </div>
          </div>
        </div>
        <!-- 英文名称 -->
        <div v-if="DetailsList.englishName" class="public-item">
          <div class="public-title">英文名称</div>
          <div class="public-text">
            <span>{{ DetailsList.englishName }}</span>
          </div>
        </div>
        <!-- 报告编号 -->
        <div v-if="DetailsList.reportCode" class="public-item">
          <div class="public-title">报告编号</div>
          <div class="public-text">
            {{ DetailsList.reportCode }}
          </div>
        </div>
        <!-- 报告页码 -->
        <div v-if="DetailsList.sizeNumber" class="public-item">
          <div class="public-title">报告页码</div>
          <div class="public-text">{{ DetailsList.sizeNumber }}页</div>
        </div>
        <!-- 图标数量 -->
        <div v-if="DetailsList.reportNumber" class="public-item">
          <div class="public-title">图表数量</div>
          <div class="public-text">{{ DetailsList.reportNumber }}个</div>
        </div>
        <!-- 寄送方式 -->
        <div v-if="DetailsList.sendWay" class="public-item">
          <div class="public-title">寄送方式</div>
          <div class="public-text">
            {{ DetailsList.sendWay }}
          </div>
        </div>
        <!-- 中文版全价 -->
        <div v-if="DetailsList.chinesePrice" class="public-item">
          <div class="public-title">中文版全价</div>
          <div class="public-text">
            {{ DetailsList.chinesePrice }}
          </div>
        </div>
        <!-- 中文电子版 -->
        <div v-if="DetailsList.electronicPrice" class="public-item">
          <div class="public-title">中文电子版</div>
          <div class="public-text">
            {{ DetailsList.electronicPrice }}
          </div>
        </div>
        <!-- 中文印刷版 -->
        <div v-if="DetailsList.printingPrice" class="public-item">
          <div class="public-title">中文印刷版</div>
          <div class="public-text">
            {{ DetailsList.printingPrice }}
          </div>
        </div>
        <!-- 英文版全价 -->
        <div v-if="DetailsList.englishPrice" class="public-item">
          <div class="public-title">英文版全价</div>
          <div class="public-text">
            {{ DetailsList.englishPrice }}
          </div>
        </div>
        <!-- 英文电子版 -->
        <div v-if="DetailsList.electronicEnglishPrice" class="public-item">
          <div class="public-title">英文电子版</div>
          <div class="public-text">
            {{ DetailsList.electronicEnglishPrice }}
          </div>
        </div>
        <!-- 英文印刷版 -->
        <div v-if="DetailsList.printingEnglishPrice" class="public-item">
          <div class="public-title">英文印刷版</div>
          <div class="public-text">
            {{ DetailsList.printingEnglishPrice }}
          </div>
        </div>
        <!-- 内容简介 -->
        <div v-if="DetailsList.content" class="public-item">
          <div class="public-title">报告导读</div>
          <div class="public-text">
            <p>{{ DetailsList.content }}</p>
            <!-- <p>Donepezil,galantamine,rivastigmine and memantine for the treatment of Alzheimer’s disease进行AD常用治疗药物的临床效果和药物经济学方面的分析。治疗药物时提供更多参考。</p> -->
          </div>
        </div>
        <!-- 目录 -->
        <div class="public-item catalogue">
          <div class="public-title">目录</div>
          <div
            :class="{ catalogueItem: DetailsList.catalogue }"
            class="public-text"
          >
            <p class="content" v-html="DetailsList.catalogue"></p>
          </div>
        </div>
      </div>
      <!-- 相似文献 -->
      <div class="bottom">
        <div class="title">相似文献</div>
        <div class="list">
          <van-list
            v-model="loading"
            :finished="finished"
            :offset="10"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <van-cell
              @click="toDetail(item.articleId)"
              v-for="item in wenxian"
              :key="item.id"
            >
              <div class="list-top">
                {{ item.title }}
              </div>
              <!-- <div class="list-bottom">
              <div class="left">
                张啸林等
              </div>
              <div class="right">
                <span>中国全科医学</span>
                <span>2021年第12期</span>
              </div>
            </div> -->
            </van-cell>
          </van-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Shelves from "./components/shelves.vue";
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Header from "@/views/mobileView/detail/components/Header.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Header,
    Shelves,
  },
  data() {
    //这里存放数据
    return {
      loading: false,
      finished: false,
      DetailsList: [],
      wenxian: [],
      pageNo: 1,
      userInfo: {},
      Share: {},
      isShelves: false,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    DetailsList() {
      this.getwenxian();
      let Share = {
        title: this.$global.matchReg(this.DetailsList.reportName) + ' - 中文知识网',
        cover: this.DetailsList.cover,
      };
      this.Share = Share;
    },
  },
  //方法集合
  methods: {
    // 头像名字跳学者\机构\期刊
    toAllParticulars(DetailsList) {
      console.log("点击了", DetailsList.userType);
      let out = this.$route.query.out;
      let web = "web";
      if (DetailsList.userType == 0) {
        //学者跳百家
        out
          ? this.$router.push(
              `/appusesbaijia?item=0&id=${DetailsList.createUser}&app=${web}&out=${out}`
            )
          : this.$router.push(
              `/appusesbaijia?item=0&id=${DetailsList.createUser}&app=${web}`
            );
      } else if (DetailsList.userType == 1) {
        //期刊跳百科
        out
          ? this.$router.push(
              `/appusesbaike?item=1&id=${DetailsList.companyId}&app=${web}&out=${out}`
            )
          : this.$router.push(
              `/appusesbaike?item=1&id=${DetailsList.companyId}&app=${web}`
            );
      } else if (DetailsList.userType == 2) {
        //机构跳机构
        out
          ? this.$router.push(
              `/appusesjigou?item=2&id=${DetailsList.companyId}&app=${web}&out=${out}`
            )
          : this.$router.push(
              `/appusesjigou?item=2&id=${DetailsList.companyId}&app=${web}`
            );
      }
    },
    getUser(data) {
      this.$apis.recomendServe
        .getAuthor({
          type: data.userType,
          userId: data.createUser,
          companyId: data.companyId ? data.companyId : "",
        })
        .then((result) => {
          this.userInfo = result.content;
        });
    },
    onLoad() {},
    // 获取详情页
    async getDetail() {
      let res = await this.$apis.recomendServe.getDetails({
        articleId: this.$route.query.id,
        articleType: this.$route.query.type,
      });
      if (res.resultCode === "200") {
        this.DetailsList = res.data.data;
        this.getUser(this.DetailsList);
      } else if (
        res.resultCode === "10401002" ||
        res.resultCode === "10401001"
      ) {
        this.isShelves = true;
      }
    },
    // 获取相似文献
    async getwenxian() {
      const { data } = await this.$apis.recomendServe.getwenxian({
        businessId2: this.DetailsList.businessId2,
        pageNo: this.pageNo,
        pageSize: 5,
      });
      try {
        this.finished = true;
        this.wenxian.push(...data.list);
        console.log(this.wenxian);
      } catch (e) {
        console.log(e);
      }
    },
    // 跳转到详情
    toDetail(id) {
      let out = this.$route.query.out;
      out
        ? this.$router.push(`/dataDetails?id=${id}&type=6&out=${out}`)
        : this.$router.push(`/dataDetails?id=${id}&type=6`);
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getDetail();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {
    this.$bus.$off("appShare");
  }, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
};
</script>
<style lang='scss' scoped>
.all {
  background: #e5e5e5;
  .content-box {
    padding-top: 70px;
    .top {
      overflow: hidden;
      padding: 20px 16px 26px 16px;
      background-color: #fff;
      .title {
        display: flex;
        // margin-top: 20px;
        .left {
          margin-right: 8px;
        }
        .right {
          .title {
            font-size: 18px;
            font-family: PingFang;
            font-weight: bold;
            color: #303030;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .author {
            font-size: 15px;
            font-family: PingFang;
            font-weight: bold;
            color: #333333;
          }
          .company {
            font-size: 15px;
            font-family: PingFang;
            font-weight: bold;
            color: #333333;
            span {
              font-size: 16px;
              font-family: PingFang;
              font-weight: 500;
              color: #666666;
            }
          }
        }
      }
      .logo {
        margin-top: 14px;
        display: flex;
        .left {
          margin-right: 10px;
        }
        .right {
          position: relative;
          top: -22px;
          .title {
            padding-top: 4px;
            font-size: 15px;
            font-family: PingFang;
            color: #333333;
            margin-top: 20px;
          }
          .time {
            padding-top: 4px;
            font-size: 10px;
            font-family: PingFang;
            font-weight: 500;
            color: #999999;
          }
        }
      }
      .author {
        span {
          padding: 0 8px;
          display: inline-block;
          border: 1px dashed #4585f5;
          border-radius: 5px;
          margin-right: 10px;
          font-size: 16px;
          font-family: PingFang;
          font-weight: 500;
          color: #4459d3;
        }
      }
    }
    .bottom {
      padding: 24px 16px 0 16px;
      margin-top: 8px;
      width: 100%;
      // height: 200px;
      background: #fff;
      .title {
        font-size: 18px;
        font-family: PingFang;
        font-weight: bold;
        color: #303030;
      }
      .list {
        .van-cell {
          padding-left: 0 !important;
          padding-right: 0 !important;
          font-size: 16px;
          font-family: PingFang;
          font-weight: 500;
          color: #303030;
          &::after {
            border-bottom: none !important;
          }
          .list-top {
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .list-bottom {
            margin-top: 5px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .left {
              font-size: 12px;
              font-family: PingFang;
              font-weight: 500;
              color: #333333;
            }
            .right {
              font-size: 12px;
              font-family: PingFang;
              font-weight: 500;
              color: #888888;
              span {
                &:nth-child(1) {
                  margin-right: 15px;
                }
              }
            }
          }
        }
      }
    }
  }
}
.public-title {
  font-size: 15px;
  font-family: PingFang;
  font-weight: bold;
  color: #333333;
  padding-bottom: 10px;
  .content {
    &::v-deep video,
    img {
      max-width: 100% !important;
    }
  }
}
.public-item {
  margin-top: 20px;
}
.public-text {
  font-size: 15px;
  font-family: PingFang;
  font-weight: 500;
  color: #333333;
  span {
    margin-right: 10px;
  }
  .per-name {
    padding: 0 8px;
    display: inline-block;
    border: 1px dashed #4585f5;
    border-radius: 5px;
    margin-right: 10px;
    font-size: 16px;
    font-family: PingFang;
    font-weight: 500;
    color: #4459d3;
  }
}
.catalogue {
  margin-bottom: 20px;
}
.catalogueItem {
  min-height: 150px;
  overflow: hidden;
  overflow-y: auto;

  p {
    height: 30px;
    line-height: 30px;
  }
}
</style>